import React from 'react';
import styled from 'styled-components';

interface ToggleButtonsProps {
	buttons: JSX.Element[];
	selected: JSX.Element;
	onClick: (button: JSX.Element) => void;
}

interface ToggleButtonsState {
	selected: JSX.Element;
}

export class ToggleButtons extends React.Component<ToggleButtonsProps, ToggleButtonsState> {
	constructor(props: ToggleButtonsProps) {
		super(props);

		this.state = { selected: props.selected };
	}

	componentWillReceiveProps(newProps: ToggleButtonsProps) {
		this.setState({ selected: newProps.selected });
	}

	render() {
		return (
			<Container>
				{this.props.buttons &&
					this.props.buttons.map((b, i) => (
						<button
							key={i}
							//sel={this.state.selected === b}
							onClick={() => {
								this.setState({ selected: b });
								this.props.onClick(b);
							}}
						>
							{b}
						</button>
					))}
			</Container>
		);
	}
}

const Container = styled.div`
	margin: 0;
	border: 0;
	font-size: 0;
`;
